import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, ErrorHandler, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';

import { OktaAuth } from '@okta/okta-auth-js';
import {
  OKTA_CONFIG,
  OktaAuthModule
} from '@okta/okta-angular';

import { AppRoutingModule } from './app-routing.module';

import { AppComponent } from './app.component';
import { LoginComponent } from './login/login.component';

import { OktaAuthGuard } from './services/authentication/oktaauth.guard';

import { LoadingService } from './services/loading/loading.service';
import { ToastrModule } from 'ngx-toastr';
import { HttpXsrfInterceptor } from './services/httpxsrfInterceptor';
import { UserIdleModule } from 'angular-user-idle';
import { SessionTimeoutDialogComponent } from './common/session-timeout-dialog/session-timeout-dialog.component';
import { ModalComponentModule, AuthenticationTemplateModule, ButtonModule } from '@crs/ivy';
import { GlobalErrorHandler } from './services/global-error-handler';
import { UnauthorizedComponent } from './unauthorized/unauthorized.component';
import { ClientService } from './services/authentication/client.service';

// TranslateHttpLoader v17+ uses dependency injection, no factory needed

@NgModule({
    declarations: [
        AppComponent,
        LoginComponent,
        SessionTimeoutDialogComponent,
        UnauthorizedComponent
    ],
    imports: [
        CommonModule,
        BrowserModule,
        OktaAuthModule,
        AppRoutingModule,
        HttpClientModule,
        BrowserAnimationsModule,
        AuthenticationTemplateModule,
        ButtonModule,
        TranslateModule.forRoot({
            loader: provideTranslateHttpLoader()
        }),
        ToastrModule.forRoot(),
        UserIdleModule.forRoot({idle: 600, timeout: 300, ping: 120}),
        ModalComponentModule,
    ],
    providers: [
        { 
            provide: OKTA_CONFIG, 
            useValue: { OktaAuth } 
        },
        {
            provide: APP_INITIALIZER,
            useFactory: (clientService: ClientService) => clientService.getClientId(),
            deps: [ ClientService ],
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: HttpXsrfInterceptor,
            multi: true,
        },
        { 
            provide: ErrorHandler,
            useClass: GlobalErrorHandler
        },
        OktaAuthGuard,
        LoadingService,
        ClientService
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }